import React from 'react';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import { styles } from './styles';
import { getDateTime } from '../../../../utils/dateTime';

const MessageTimeBadge = ({ date, fullDate }) => {
  const renderBadge = () => {
    const now = DateTime.now();
    const today = now.startOf('day');
    const yesterday = now.minus({ days: 1 }).startOf('day');
    const timestamp = DateTime.fromJSDate(new Date(date));
    const isToday = timestamp.hasSame(today, 'day');
    const isYesterday = timestamp.hasSame(yesterday, 'day');
    const isAnotherYear = !timestamp.hasSame(today, 'year');

    if (isToday) {
      return 'Today';
    }
    if (isYesterday) {
      return 'Yesterday';
    }
    if (isAnotherYear) {
      return timestamp.toFormat('MMMM dd, yyyy');
    }
    return timestamp.toFormat('MMMM dd');
  };

  return (
    <div style={styles.messageTimeBadge}>
      <p style={{ whiteSpace: 'nowrap', color: '#6b778c', margin: 0 }}>
        {fullDate ? getDateTime(date, 'MMMM dd, yyyy') : renderBadge()}
      </p>
    </div>
  );
};

MessageTimeBadge.propTypes = {
  date: PropTypes.string.isRequired,
  fullDate: PropTypes.bool,
};
MessageTimeBadge.defaultProps = {
  fullDate: undefined,
};


export default MessageTimeBadge;
